module.exports = __webpack_public_path__ + "709a4194d5335d661478ac9373071aeb.svg";